import React, { lazy } from "react";
import { Route } from "react-router-dom";
import Verify from "../Pages/Verify/Verify.jsx";
const Successful = lazy(() => import("../Pages/Successful/Successful.jsx"));
const StDashboard = lazy(() =>
  import("../Student Dashboard/Dashboard/StudentDashboard.jsx")
);
const MyProfile = lazy(() =>
  import("../Student Dashboard/My Profile/MyProfile.jsx")
);
const Courses = lazy(() => import("../Student Dashboard/Courses/Courses.jsx"));
const Wishlist = lazy(() =>
  import("../Student Dashboard/Wishlist/Wishlist.jsx")
);
const ScheduleList = lazy(() =>
  import("../Student Dashboard/ScheduleList/ScheduleList.jsx")
);
const AllJobs = lazy(() => import("../Student Dashboard/All Jobs/AllJobs.jsx"));
const StudentRoutes = (
  <>
    <Route path="/stdashboard" element={<StDashboard />} />
    <Route path="/myprofile" element={<MyProfile />} />
    <Route path="/jobs" element={<Courses />} />
    <Route path="/all-jobs" element={<AllJobs />} />
    <Route path="/wishlist" element={<Wishlist />} />
    <Route path="/schedulelist" element={<ScheduleList />} />
    <Route path="/successful" element={<Successful />} />
    <Route path="/verify" element={<Verify />} />
  </>
);

export default StudentRoutes;
